<template>

    <div class="mb-3" :class="{'form-floating': floating}">

        <label v-if="label && floating === false" class="form-label" :for="id">
            {{ translatedLabel }}
            <span v-if="help">
                <i class="bi bi-question-circle" :title="help"></i>
            </span>
        </label>

        <select 
            :id="id" 
            ref="input" 
            v-model="selected" 
            v-bind="$attrs" 
            class="form-select"
            :class="{ 'is-invalid': error }">
            <slot />
        </select>

        <label v-if="label && floating" class="form-label" :for="id">
            {{ translatedLabel }}
        </label>

        <div v-if="error" class="invalid-feedback">{{ error }}</div>

    </div>

</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            id: {
                type: String,
                default() {
                    return `select-input-${this._uid}`
                },
            },
            value: [String, Number, Boolean, Array],
            floating: {
                default: false,
            },
            label: String,
            error: String,
            help: String,
        },
        data() {
            return {
                selected: this.value,
            }
        },
        watch: {
            selected(selected) {
                this.$emit('input', selected)
            },
            value() {
                this.selected = this.value;
            }
        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
        methods: {
            focus() {
                this.$refs.input.focus()
            },
            select() {
                this.$refs.input.select()
            },
        },
    }
</script>
